// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import APIURL from "../../common/Config";
// import ApiManager from "../../api-manager/ApiManager.component";
// import "./Astrologerverify.css";
// import Header from "../header/header";
// import Footer from "../footer/footer";

// const DocumentUpload = () => {
//   const [documents, setDocuments] = useState({
//     aadharFront: null,
//     aadharBack: null,
//     panCard: null,
//     certificate: null, 
//   });
//   const [previews, setPreviews] = useState({
//     aadharFront: null,
//     aadharBack: null,
//     panCard: null,
//     certificate: null, 
//   });
//   const [astrologerId, setAstrologerId] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAstrologerId = async () => {
//       const storedAstrologer = await ApiManager.getData("ASTROLOGERID");
//       if (storedAstrologer) {
//         setAstrologerId(storedAstrologer);
//       } else {
//         alert("Astrologer ID not found. Please complete registration first.");
//         navigate("/astrologer-registration");
//       }
//     };

//     fetchAstrologerId();
//   }, [navigate]);

//   const handleFileChange = (type, e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (file.size > 500 * 1024) {
//       alert("File size must be less than 500KB");
//       e.target.value = "";
//       return;
//     }

//     if (!["image/jpeg", "image/jpg", "application/pdf"].includes(file.type)) {
//       alert("Invalid file type. Only JPG, JPEG, PDF allowed.");
//       e.target.value = "";
//       return;
//     }

//     setDocuments((prev) => ({ ...prev, [type]: file }));
    
    
//     if (file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setPreviews((prev) => ({ ...prev, [type]: e.target.result }));
//       };
//       reader.readAsDataURL(file);
//     } else if (file.type === "application/pdf") {
      
//       setPreviews((prev) => ({ ...prev, [type]: "pdf" }));
//     }
//   };

//   const handleVerify = async () => {
//     if (!documents.aadharFront || !documents.aadharBack || !documents.panCard) {
//       alert("Please upload all required documents.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("contentFiles", documents.aadharFront);
//     formData.append("contentFiles", documents.aadharBack);
//     formData.append("contentFiles", documents.panCard);
    
    
//     if (documents.certificate) {
//       formData.append("contentFiles", documents.certificate);
//     }

//     try {
//       const response = await axios.post(
//         `${APIURL}/astro-docs/save?astrologerId=${encodeURIComponent(astrologerId)}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Accept: "*/*",
//           },
//         }
//       );
//       console.log("Document Upload Success:", response.data);
//       alert("Documents uploaded successfully. Your profile is under review.");
//       navigate("/app-downloads");
//     } catch (error) {
//       console.error("Upload failed:", error);
//       alert("Upload failed: " + (error.response?.data?.message || "Unknown error"));
//     }
//   };

//   const renderDocumentPreview = (type) => {
//     if (!previews[type]) return null;
    
//     if (previews[type] === "pdf") {
//       return (
//         <div className="pdf-preview">
//           <div className="pdf-icon">PDF</div>
//           <div className="pdf-filename">{documents[type]?.name}</div>
//         </div>
//       );
//     } else {
//       return (
//         <div className="image-preview">
//           <img src={previews[type]} alt={`Preview of ${type}`} />
//         </div>
//       );
//     }
//   };

//   const documentTypes = [
//     { type: "aadharFront", label: "Aadhar Card Front", icon: "📄", required: true },
//     { type: "aadharBack", label: "Aadhar Card Back", icon: "📄", required: true },
//     { type: "panCard", label: "PAN Card", icon: "📄", required: true },
//     { type: "certificate", label: "Certificate", icon: "🎓", required: false }, 
//   ];

//   return (
//     <div>
//       <Header />
//       <div className="document-upload-container">
//         <h2 className="upload-heading">Document Verification</h2>
        
//         <div className="instructions">
//           <p className="instruction-item">
//             Please upload your Aadhaar and PAN details ensuring they match your personal details.
//           </p>
//           <p className="instruction-item">
//             All documents must be clear, complete, and valid.
//           </p>
//           <p className="instruction-item">
//             You can also upload your certificates or qualifications (optional).
//           </p>
//           <p className="instruction-item">
//             JPG, JPEG, PDF Format are supported (Below 500KB)
//           </p>
//         </div>

//         <div className="document-grid">
//           {documentTypes.map(({ type, label, icon, required }) => (
//             <div className="document-card" key={type}>
//               <div className="document-card-header">
//                 <span className="document-icon">{icon}</span>
//                 <span className="document-title">
//                   {label} {required ? <span className="required-mark">*</span> : <span className="optional-mark">(Optional)</span>}
//                 </span>
//               </div>
              
//               <div className="document-content">
//                 {documents[type] ? (
//                   <div className="preview-container">
//                     {renderDocumentPreview(type)}
//                     <div className="file-info">
//                       <div className="file-name">{documents[type].name}</div>
//                       <div className="file-size">{(documents[type].size / 1024).toFixed(1)} KB</div>
//                     </div>
//                     <button 
//                       className="change-button"
//                       onClick={() => document.getElementById(type).click()}
//                     >
//                       Change
//                     </button>
//                   </div>
//                 ) : (
//                   <div className="upload-area" onClick={() => document.getElementById(type).click()}>
//                     <div className="upload-icon">+</div>
//                     <div className="upload-text">Upload from files</div>
//                     <div className="upload-format">JPG, JPEG, PDF (Max 500KB)</div>
//                   </div>
//                 )}
//                 <input
//                   type="file"
//                   id={type}
//                   className="file-input"
//                   accept=".jpg,.jpeg,.pdf"
//                   onChange={(e) => handleFileChange(type, e)}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="verify-button-container">
//           <button onClick={handleVerify} className="verify-button">
//             VERIFY DOCUMENTS
//           </button>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default DocumentUpload;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import APIURL from "../../common/Config";
import ApiManager from "../../api-manager/ApiManager.component";
import "./Astrologerverify.css";
import Header from "../header/header";
import Footer from "../footer/footer";

const DocumentUpload = () => {
  const [documents, setDocuments] = useState([]);
  const [astrologerId, setAstrologerId] = useState("");
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  const defaultDocuments = [
    { type: "aadharFront", label: "Aadhar Card Front", icon: "📄", required: true },
    { type: "aadharBack", label: "Aadhar Card Back", icon: "📄", required: true },
    { type: "panCard", label: "PAN Card", icon: "📄", required: true },
    { type: "certificate", label: "Certificate", icon: "🎓", required: false },
  ];

  useEffect(() => {
    const fetchAstrologerId = async () => {
      const storedAstrologer = await ApiManager.getData("ASTROLOGERID");
      if (storedAstrologer) {
        setAstrologerId(storedAstrologer);
        initializeDocuments();
      } else {
        alert("Astrologer ID not found. Please complete registration first.");
        navigate("/astrologer-registration");
      }
    };

    fetchAstrologerId();
  }, [navigate]);

  const initializeDocuments = () => {
    const initialDocs = defaultDocuments.map((doc) => ({
      ...doc,
      file: null,
      preview: null,
    }));
    setDocuments(initialDocs);
  };

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 500 * 1024) {
      alert("File size must be less than 500KB");
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/jpg", "application/pdf"].includes(file.type)) {
      alert("Invalid file type. Only JPG, JPEG, PDF allowed.");
      e.target.value = "";
      return;
    }

    const updatedDocs = [...documents];
    updatedDocs[index].file = file;

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        updatedDocs[index].preview = e.target.result;
        setDocuments([...updatedDocs]);
      };
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      updatedDocs[index].preview = "pdf";
      setDocuments([...updatedDocs]);
    }
  };

  const handleAddDocument = () => {
    const newDoc = {
      type: `document_${documents.length}`,
      label: "Additional Document",
      icon: "📄",
      required: false,
      file: null,
      preview: null,
    };
    setDocuments([...documents, newDoc]);
  };

  const handleRemoveDocument = (index) => {
    if (documents[index].required) {
      alert("Cannot remove required documents.");
      return;
    }
    setDocuments(documents.filter((_, i) => i !== index));
  };

  const handleVerify = async () => {
    // Check required documents
    const requiredDocs = documents.filter((doc) => doc.required);
    if (requiredDocs.some((doc) => !doc.file)) {
      alert("Please upload all required documents.");
      return;
    }

    if (documents.length === 0 || !documents.some((doc) => doc.file)) {
      alert("Please upload at least one document.");
      return;
    }

    setUploading(true);

    const formData = new FormData();
    const documentNames = [];

    documents.forEach((doc) => {
      if (doc.file) {
        formData.append("contentFiles", doc.file);
        // Generate document name: use label with underscores
        const docName = doc.label.replace(/\s+/g, "_");
        documentNames.push(docName);
      }
    });

    try {
      const queryParams = new URLSearchParams();
      queryParams.append("astrologerId", encodeURIComponent(astrologerId));
      documentNames.forEach((name) => {
        queryParams.append("documentNames", name);
      });

      const response = await axios.post(
        `${APIURL}/astro-docs/save?${queryParams.toString()}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*/*",
          },
        }
      );
      console.log("Document Upload Success:", response.data);
      alert("Documents uploaded successfully. Your profile is under review.");
      navigate("/app-downloads");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed: " + (error.response?.data?.message || "Unknown error"));
    } finally {
      setUploading(false);
    }
  };

  const renderDocumentPreview = (doc) => {
    if (!doc.preview) return null;

    if (doc.preview === "pdf") {
      return (
        <div className="pdf-preview">
          <div className="pdf-icon">PDF</div>
          <div className="pdf-filename">{doc.file?.name}</div>
        </div>
      );
    } else {
      return (
        <div className="image-preview">
          <img src={doc.preview} alt={`Preview of ${doc.label}`} />
        </div>
      );
    }
  };

  return (
    <div>
      <Header />
      <div className="document-upload-container">
        <h2 className="upload-heading">Document Verification</h2>

        <div className="instructions">
          <p className="instruction-item">
            Please upload your Aadhaar and PAN details ensuring they match your personal details.
          </p>
          <p className="instruction-item">
            All documents must be clear, complete, and valid.
          </p>
          <p className="instruction-item">
            You can also upload your certificates or qualifications (optional).
          </p>
          <p className="instruction-item">
            JPG, JPEG, PDF Format are supported (Below 500KB)
          </p>
        </div>

        <div className="document-grid">
          {documents.map((doc, index) => (
            <div className="document-card" key={index}>
              <div className="document-card-header">
                <span className="document-icon">{doc.icon}</span>
                <span className="document-title">
                  {doc.label}{" "}
                  {doc.required ? (
                    <span className="required-mark">*</span>
                  ) : (
                    <span className="optional-mark">(Optional)</span>
                  )}
                </span>
              </div>

              <div className="document-content">
                {doc.file ? (
                  <div className="preview-container">
                    {renderDocumentPreview(doc)}
                    <div className="file-info">
                      <div className="file-name">{doc.file.name}</div>
                      <div className="file-size">{(doc.file.size / 1024).toFixed(1)} KB</div>
                    </div>
                    <button
                      className="change-button"
                      onClick={() => document.getElementById(`file-${index}`).click()}
                    >
                      Change
                    </button>
                    {!doc.required && (
                      <button
                        className="remove-button"
                        onClick={() => handleRemoveDocument(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                ) : (
                  <div
                    className="upload-area"
                    onClick={() => document.getElementById(`file-${index}`).click()}
                  >
                    <div className="upload-icon">+</div>
                    <div className="upload-text">Upload from files</div>
                    <div className="upload-format">JPG, JPEG, PDF (Max 500KB)</div>
                  </div>
                )}
                <input
                  type="file"
                  id={`file-${index}`}
                  className="file-input"
                  accept=".jpg,.jpeg,.pdf"
                  onChange={(e) => handleFileChange(index, e)}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="add-document-container">
          <button onClick={handleAddDocument} className="add-document-button">
            + Add More Documents
          </button>
        </div>

        <div className="verify-button-container">
          <button
            onClick={handleVerify}
            className="verify-button"
            disabled={uploading}
          >
            {uploading ? "UPLOADING..." : "VERIFY DOCUMENTS"}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DocumentUpload;